import { Button } from "@/components";
import { Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { FONT } from "@styles/common";

export const YearMonth = ({ date, setDate }: { date: Date; setDate: React.Dispatch<React.SetStateAction<Date>> }) => {
    const isPreviousMonthDisabled =
        date.getMonth() === new Date().getMonth() && date.getFullYear() === new Date().getFullYear();
    return (
        <Flex justifyContent={"center"} alignItems="center" rowGap="16px">
            <Button
                border="none"
                iconNamed="arrow_back_ios"
                iconSized={24}
                style={{
                    opacity: isPreviousMonthDisabled ? "0" : "1",
                    cursor: isPreviousMonthDisabled ? "auto" : "pointer",
                }}
                disabled={isPreviousMonthDisabled}
                onClick={() => {
                    const newDate = new Date(date.setMonth(date.getMonth() - 1));
                    setDate(newDate);
                }}
            ></Button>
            <CustomDateText w="100%" whiteSpace="nowrap">
                {date.getFullYear()}. {String(date.getMonth() + 1).padStart(2, "0")}
            </CustomDateText>
            <Button
                border="none"
                iconNamed="arrow_forward_ios"
                iconSized={24}
                onClick={() => {
                    const newDate = new Date(date.setMonth(date.getMonth() + 1));
                    setDate(newDate);
                }}
            ></Button>
        </Flex>
    );
};

const CustomDateText = styled(Text)`
    ${FONT("pretendard", 32, 700, 1)};
    color: ${({ theme }) => theme.COLOR.black};
`;
